

import outreachReducer from './OutreachReducer'
export { outreachReducer }

export * from './OutreachActions'



// WEBPACK FOOTER //
// ./src/store/outreach/index.js